module.exports = __webpack_public_path__ + "img/P596.bc5e87d0.jpg";